module.exports = __webpack_public_path__ + "images/gta-5_rgba(0,0,0,0.7).a815fe3debf7abf2132eb7aa30d55bb9.jpg";